import { getCurrentSubscription } from './subscribe'

// Best-effort teardown of THIS device's push subscription on sign-out, so a shared device stops receiving
// the previous user's notifications. The Firestore doc is deliberately left — the server prunes it on the
// next 404/410. Fails soft: no service worker, no subscription, or an error must not throw into sign-out.
export async function unsubscribePushThisDevice(): Promise<void> {
  try {
    const subscription = await getCurrentSubscription()
    if (subscription) await subscription.unsubscribe()
  } catch {
    // best-effort only — nothing to tear down or the browser refused
  }
}
